import "/assets/styles/sections/home/featured-numbers.scss";

// Partials
import Icon from '@wearetla/tla-essentials-tools/partials/icon';

const FeaturedNumbers = () => {
	return (
		<main
			id="numbers"
			className="section home-numbers">
			<div className="numbers-wrap wrapper">
        <div className="numbers-heading">
          <strong className="heading-pretitle">Trust and Performance:</strong>
          <h3 className="heading-title">Our Impact in Numbers</h3>
        </div>
				
        <ul className="numbers-items">
          <li className="items-item">
            <Icon
              name="calendar-check"
              className="item-icon" />
            <span className="item-number">100+</span>
            <strong className="item-title">Events</strong>
          </li>
          <li className="items-item">
            <Icon
              name="users"
              className="item-icon" />
            <span className="item-number">150.000+</span>
            <strong className="item-title">Visitors</strong>
          </li>
          <li className="items-item">
            <Icon
              name="bill"
              className="item-icon" />
            <span className="item-number">1.500.000+</span>
            <strong className="item-title">Transactions</strong>
          </li>
          <li className="items-item">
            <Icon
              name="secure"
              className="item-icon" />
            <span className="item-number">99.9%</span>
            <strong className="item-title">Uptime</strong>
          </li>
        </ul>
			</div>
		</main>
	);
};

export default FeaturedNumbers;
